import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
} from '@mui/material'
import { createOrg, setWorkspace } from '../features/org/orgSlice'

const slugify = (s) =>
  s
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)

function CreateOrgDialog({ open, onClose }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [slug, setSlug] = useState('')
  const [slugTouched, setSlugTouched] = useState(false)
  const [saving, setSaving] = useState(false)

  const effectiveSlug = slugTouched ? slug : slugify(name)

  const handleClose = () => {
    setName('')
    setSlug('')
    setSlugTouched(false)
    onClose()
  }

  const handleCreate = async () => {
    if (!name.trim()) return
    setSaving(true)
    const result = await dispatch(createOrg({ name: name.trim(), slug: effectiveSlug }))
    setSaving(false)
    if (createOrg.fulfilled.match(result)) {
      toast.success(`${result.payload.name} created`)
      dispatch(setWorkspace(result.payload.slug))
      handleClose()
      navigate(`/orgs/${result.payload.slug}`)
    } else {
      toast.error(result.payload || 'Could not create organisation')
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Create an organisation</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          An organisation owns a shared set of bowties. You'll be its first admin and can invite
          colleagues.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          label="Organisation name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="URL handle"
          value={effectiveSlug}
          onChange={(e) => {
            setSlugTouched(true)
            setSlug(slugify(e.target.value))
          }}
          helperText={
            <Box component="span">
              bowtie.app/orgs/<strong>{effectiveSlug || 'your-org'}</strong>
            </Box>
          }
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleCreate}
          disabled={!name.trim() || !effectiveSlug || saving}
          sx={{ textTransform: 'none', backgroundColor: '#E67E22', '&:hover': { backgroundColor: '#D35400' } }}
        >
          {saving ? 'Creating…' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CreateOrgDialog
